import { useEffect } from "react";
import "./index.css";
var useRipple = function useRipple(dom, enable) {
  var createRipple = function createRipple(ev) {
    if (!enable) return;
    var $dom = ev.target;
    $dom.classList.add("ykRipple");
    var delta = 7;
    var bounding = $dom.getBoundingClientRect();
    var x = ev.clientX - bounding.x;
    var y = ev.clientY - bounding.y;
    var size = 0;
    var scale = "";
    var start = "";
    var end = "";
    if ($dom.clientWidth > $dom.clientHeight) {
      size = $dom.clientHeight + delta;
      scale = "".concat($dom.clientWidth * 1.5 / size);
      start = "".concat(x - size / 2, "px, ").concat(y - size / 2, "px");
      end = "".concat($dom.clientWidth / 2 - size / 2, "px, 0px");
    } else {
      size = $dom.clientWidth + delta;
      scale = "".concat($dom.clientHeight * 1.5 / size);
      start = "".concat(x - size / 2, "px, ").concat(y - size / 2, "px");
      end = "0px, ".concat($dom.clientHeight / 2 - size / 2, "px");
    }
    $dom.style.setProperty("--yk-ripple-size", "".concat(size, "px"));
    $dom.style.setProperty("--yk-ripple-translate-start", start);
    $dom.style.setProperty("--yk-ripple-translate-end", end);
    $dom.style.setProperty("--yk-ripple-scale", scale);
    $dom.classList.add("ykRipple--update");
  };
  var removeRipple = function removeRipple(ev) {
    ev.target.classList.remove("ykRipple--update");
  };
  useEffect(function () {
    var _dom$current, _dom$current2;
    (_dom$current = dom.current) === null || _dom$current === void 0 ? void 0 : _dom$current.addEventListener("mousedown", createRipple);
    (_dom$current2 = dom.current) === null || _dom$current2 === void 0 ? void 0 : _dom$current2.addEventListener("animationend", removeRipple);
  }, [enable]);
};
export default useRipple;